<template>
  <div class="container testimonials" id="testimonials">
    <div class="content-heading is-flex">
      <h3 class="is-size-3">Locations</h3>
      <router-link to="/admin/locations/new" class="button is-info">Add New</router-link>
    </div>

    <transition mode="out-in" name="fade">
      <modal @close="showModal = false" :kind="kind" v-if="showModal" :header="header"/>
    </transition>

    <router-view></router-view>

    <div class="box">
      <table class="table is-fullwidth is-striped">
        <thead>
          <tr>
            <th>
              Name
            </th>
            <!--<th>-->
              <!--Type-->
            <!--</th>-->
            <!--<th>-->
              <!--Location-->
            <!--</th>-->
            <!--<th>-->
              <!--State-->
            <!--</th>-->
          </tr>
        </thead>
        <tbody>
          <tr v-for="(location, index) in locations" :key="index">
            <td>
              <p>
                <router-link :to="'/admin/locations/edit/' + location['.key']">
                  {{location.name}}
                </router-link>
              </p>
            </td>
            <!--<td>-->
              <!--<p>{{location.type}}</p>-->
            <!--</td>-->
            <!--<td>{{location.location}}</td>-->
            <!--<td>{{location.state}}</td>-->
          </tr>
        </tbody>
      </table>
    </div>

    <!-- notification -->
    <transition mode="out-in" name="fade">
      <div v-if="notification.message" :class="'notification is-' + notification.type">
        <button class="delete" @click="hideNotifications"></button>{{notification.message}}
      </div>
    </transition>
  </div>
</template>

<script>
// import firebase from 'firebase'
import { locationsRef } from '@/firebase_config'
import modal from '@/components/shared/Modal'
import notifier from '@/mixins/notifier'

export default {
  name: 'locations',
  data () {
    return {
      showModal: false,
      header: '',
      kind: '',
      location: null,
      sortKey: 'title'
    }
  },
  firebase: {
    locations: locationsRef
  },
  mixins: [notifier],
  computed: {},
  methods: {},
  components: {
    modal
    // dropdown,
    // checkbox
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/content/Locations.vue